import ContentfulEntry from 'models/data/contentful/ContentfulEntry'
import ContentfulRichText from "models/data/contentful/ContentfulRichText";
import { get } from 'lodash'

class ContentfulTextEssay {
	static default = {
		id: "",
		title: "",
		subtitle: "",
		bodyHtml: "",
		imageUrls: []
	};

	static id = contentfulTextEssay => ContentfulEntry.id(contentfulTextEssay);

	static title = contentfulTextEssay => {
		const fields = ContentfulEntry.fields(contentfulTextEssay);
		const title = get(fields, "title", ContentfulTextEssay.default.title);
		return title;
	};

	static subtitle = contentfulTextEssay => {
		const fields = ContentfulEntry.fields(contentfulTextEssay);
		const subtitle = get(fields, "subtitle", ContentfulTextEssay.default.subtitle);
		return subtitle;
	};

	static bodyHtml = contentfulTextEssay => {
        const fields = ContentfulEntry.fields(contentfulTextEssay);
        const body = get(fields, 'body', {})
        const bodyHtml = ContentfulRichText.toHtml(body)
        return bodyHtml
    };
    
    static images = contentfulTextEssay => {
        const fields = ContentfulEntry.fields(contentfulTextEssay);
        const body = get(fields, 'body', {})
        const images = ContentfulRichText.images(body)
        return images
    }
}

export default ContentfulTextEssay;